import { isFile } from '~/utils/file';
import api from '~/services/api';
import { ICurrentClinic } from '~/services/api/clinic/types';

const withUploadedLogo = async (data: ICurrentClinic): Promise<ICurrentClinic> => {
  if (!isFile(data.logo)) return data;

  const formData = new FormData();
  formData.append('file', data.logo);
  const { fileName } = await api.file.uploadFile(formData).then(r => r.data);
  return { ...data, logo: fileName };
};

export default withUploadedLogo;
